import * as React from "react";
import { forwardRef } from "react";
const SvgDeviceMobile = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", width: 24, height: 24, strokeWidth: 1, strokeLinejoin: "round", strokeLinecap: "round", stroke: "currentColor", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z" }), /* @__PURE__ */ React.createElement("path", { d: "M11 4h2" }), /* @__PURE__ */ React.createElement("path", { d: "M12 17v.01" }));
const ForwardRef = forwardRef(SvgDeviceMobile);
export default ForwardRef;
